/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Body } from '../../Layouts/Body'
import { iCardPesquisa, iFeedbackPersonalizadoQuery } from '../../../interfaces'
import { appApi } from '../../../services/appApi'
import { CardPesquisa } from './Components/CardPesquisa'
import { Flex, useToast } from '@chakra-ui/react'
import { ButtonCmp } from '../../../components/ButtonCmp'
import { ImgSah } from '../../../components/ImgSah'
import LoadingContainer from '../../../components/LoadingContainer'
import { SearchCmp } from '../../../components/SearchCmp'

export const SelecionarJaExistente: React.FC = () => {
  const { pathname } = useLocation()
  const nav = useNavigate()

  const queryParams: iFeedbackPersonalizadoQuery = Object.fromEntries(new URLSearchParams(window.location.search).entries())
  const [Pesquisas, setPesquisas] = useState<iCardPesquisa[]>([])
  const [SearchText, setSearchText] = useState('')
  const toast = useToast()
  const [IsLoading, setIsLoading] = useState(false)

  function getPesquisas(): void {
    setIsLoading(true)
    appApi.get('FeedbackPersonalizado/PesquisasJaCriadas')
      .then(response => {
        setPesquisas(response.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function selecionarPesquisa(pid: string): void {
    appApi.patch(`/FeedbackPersonalizado/${queryParams.feedbackId}/ItemFeedback/${pid}?itemFeedbackId=${queryParams.itemFeedbackId}&fase=${queryParams.fase}&jaCriada=true`)
      .then(() => {
        toast({
          title: 'Pesquisa selecionada com sucesso',
          duration: 4000,
          status: 'success',
          position: 'top'
        })
        nav(-1)
      })
      .catch((err) => console.log(err))
  }

  useEffect(() => {
    getPesquisas()
  }, [pathname])

  return (
    <Body>
      <Flex justifyContent={'space-between'} margin='1.75rem 0rem'>
        <h1>Pesquisas de competências</h1>
      </Flex>
      <Flex alignItems={'end'} marginBottom='1rem' justifyContent={'space-between'}>
        <Flex gap={'.5rem'} justifyContent={'end'}>
          <SearchCmp
            EnterAction={getPesquisas}
            OnChange={setSearchText}
            placeholder={'Pesquisa'}
          />
        </Flex>

      </Flex>

      <LoadingContainer linhas={18} loading={IsLoading}>
          <Flex flexDir={'column'} gap='.5rem'>
            {Pesquisas.length !== 0 &&
              Pesquisas.filter(e => {
                if (SearchText === '' || !SearchText) {
                  return e
                } else if (e.nomePesquisa.toLowerCase().includes(SearchText.toLowerCase())) {
                  return e
                }

                return null
              }).map((p: iCardPesquisa, i) => {
                return (
                  <CardPesquisa
                    key={i}
                    pesquisa={p}
                    onSelect={(pid) => selecionarPesquisa(pid)}
                  />
                )
              }
              )
            }
          </Flex>
        </LoadingContainer>

      {
        (Pesquisas?.length === 0 && !IsLoading) && (
          <ImgSah textoPersonalizado={'Você não possuí nenhuma pesquisa de competências já criada para utilizar no seu feedback'}>
            <ButtonCmp
              VarColor='c6'
              size={'lg'}
              onClick={() => nav(-1)}
            >Voltar</ButtonCmp>
          </ImgSah>
        )
      }
    </Body>
  )
}
